// import React, { useState } from 'react';
// import PollItem from "./PollSection/PollItem";
import { previousPollsResultStyle as styles } from './previousPollsResult.tailwind';
import { useSelector } from 'react-redux';
import noPollsIcon from '../../../../../assets/svgs/no_polls.svg';
import Polls from '../CurrentPolls/Polls';
import PollSkeleton from '../../../shared/Skeletons/PollSkeleton/PollSkeleton';

const PreviousPollsResult = () => {
  const { previousPolls, isPreviousPollsLoading } = useSelector((state) => state?.earnPoint || {});
  const { user } = useSelector((state) => state?.user || {});
  const userId = user?.userDetails?._id;

  // const [openIndex, setOpenIndex] = useState(0);

  // const togglePoll = (index) => {
  //   setOpenIndex(openIndex === index ? null : index);
  // };

  // Filter for attempted polls
  const attemptedPolls = previousPolls?.filter(poll =>
    poll?.pollOptions?.some(option =>  
      option?.voteDetails?.some(vote => 
        vote?.userIds?.some(_userId => _userId === userId)
      )
    )
  ) || [];

  return (
    <div className={styles.outerContainer}>
      <span className={styles.heading}>
        Previous Polls
        {/* <div className={styles.dividerContainer}>
          <div className={`${styles.divider} w-[30px] md:w-[50px]`}></div>
          <div className={`${styles.divider} w-[10px] md:w-[30px]`}></div>
          <div className={`${styles.divider} w-[5px] md:w-[25px]`}></div>
        </div> */}
      </span>

      {isPreviousPollsLoading ? (
        <div className={styles.skeletonContainer}> 
          <PollSkeleton count={2} />
        </div>
      ) : (
        <div className={styles.pollsContainer}>
          {attemptedPolls.length > 0 ? (
            <div className={styles.insidePollsContainer}>
              {attemptedPolls.map((poll, index) => (
                <Polls
                  key={index}
                  poll={poll}
                  question={poll?.pollTitle}
                  options={poll?.pollOptions?.map((option) => ({
                      label: option?.optionTitle,
                      votes: option?.votes,
                      id: option?._id,
                      voteDetails: option?.voteDetails
                  })) || []}
                  pollIndex={index}
                  pollId={poll?._id}
                  userId={userId}
                  onSubmit={() => {}}
                  isLivePoll={false}
                  isPollAttempted={true}
                />
              ))}
            </div>
          ) : (
            <div className={`${styles.noPollsContainer}`}>
              <img
                src={noPollsIcon}
                alt="No polls"
                className={styles.noPollsImage}
              />
              <p className={styles.noPollsText}>No Previous polls found</p>
            </div>
          )}
        </div>
      )}
    </div>
  )
}

export default PreviousPollsResult